// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ns","side":"e_os","main":"e_ps","reversed":"e_qs"};